import React from "react";
import { Table, ButtonToolbar, ButtonGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";

const StudentTable = (props) => {
  const intl = useIntl();
  var students = props.students;

  students = students.sort((a, b) => {
    return a.name > b.name ? 1 : -1;
  });

  if (props.filter && props.filter.length > 0) {
    students = props.students.filter((t) => {
      return (
        t.name.toLowerCase().indexOf(props.filter) !== -1 ||
        t.email.toLowerCase().indexOf(props.filter) !== -1
      );
    });
  }

  let studentCourses = props.studentCourses ? props.studentCourses : [];

  let studentLicenses = [];

  var mappedStudents = students.map((student, id) => {
    studentCourses
      .filter((x) => x.studentId === student.id)
      .forEach((programLicense) => {
        if (studentLicenses.indexOf(programLicense.programLicenseName) === -1)
          studentLicenses.push(programLicense.programLicenseName);
      });
    return (
      <tr key={id} style={{ verticalAlign: "middle" }}>
        <td className="text-center">{student.id}</td>
        <td>
          <Button
            title={intl.formatMessage({ id: "GoToStudentPage" })}
            className="ps-0"
            color="link"
            onClick={() =>
              props.goToStudentPage(student.id, student.class.name)
            }
            disabled={studentLicenses.length === 0}
          >
            {student.name}
          </Button>
        </td>
        <td>{student.email}</td>
        {props.showClass && <td>{student.class.name}</td>}

        <td>
          <ul className="list-unstyled">
            {studentLicenses.map((license, i) => (
              <li key={i}>{license}</li>
            ))}
          </ul>
        </td>

        <td>
          <ButtonToolbar className="float-end">
            <ButtonGroup size="sm">
              <ButtonSendActivationMail className="float-end" user={student} />
              {/* TODO studenten behöver förväljas i shopen */}
              {/* <Button
                  title={"Köp licens till: " + student.name}
                  color="primary"
                  outline
                  onClick={() => props.goToShop(student.id)}
                >
                  <FontAwesomeIcon icon={"shopping-cart"} />
                </Button> */}
              <Button
                title={intl.formatMessage({ id: "EditInformationFor" }, { name: student.name })}
                outline
                color="primary"
                onClick={() => props.toggleEdit(student)}
              >
                <FontAwesomeIcon icon="edit" />
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </td>
      </tr>
    );
  });

  return (
    <Table hover responsive striped className="school-table">
      <thead>
        <tr>
          <th className="text-center">Id</th>
          <th><FormattedMessage id="Name" /></th>
          <th><FormattedMessage id="Email" /></th>
          {props.showClass && <th><FormattedMessage id="Class" /></th>}
          <th><FormattedMessage id="Licenses" /></th>
          <th />
        </tr>
      </thead>
      <tbody>{mappedStudents}</tbody>
    </Table>
  );
};

export default StudentTable;
